import PropTypes from 'prop-types';
import styles from './ButtonFooter.module.css';

const ButtonFooter = ({ disabled = false, children, marginTop = 20 }) => {
  return (
    <div
      className={disabled ? styles.disabled : ''}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
        columnGap: 8,
        marginTop: marginTop,
      }}>
      {children}
    </div>
  );
};

ButtonFooter.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node,
  marginTop: PropTypes.number,
};

export default ButtonFooter;
